import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: null,
    lists: [],
    darkMode: false
  },
  mutations: {
    initialiseStore(state) {
      if (localStorage.getItem("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("store")))
        );
      }
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setLists(state, payload) {
      state.lists = payload;
    },
    addList(state, payload) {
      state.lists.push(payload);
    },
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
    }
  },
  actions: {},
  modules: {}
});

store.commit("initialiseStore");

store.subscribe((_mutation, state) => {
  localStorage.setItem("store", JSON.stringify(state));
});

export default store;
